import script from "./RevShare.vue?vue&type=script&setup=true&lang=js"
export * from "./RevShare.vue?vue&type=script&setup=true&lang=js"

import "./RevShare.vue?vue&type=style&index=0&id=595fd297&lang=scss&scoped=true"
import "./RevShare.vue?vue&type=style&index=1&id=595fd297&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595fd297"]])

export default __exports__